module.exports = __webpack_public_path__ + "img/saba_tas_no.ea436c13.png";